import { concatStyleSets, ITheme, memoizeFunction } from "@fluentui/react";
import { IButtonStyles } from "@fluentui/react/lib/Button";
import { FontWeights, mergeStyleSets } from "@fluentui/react/lib/Styling";

import { ActionControlSize } from "@1js/acui-common";

import { getActionButtonStyles } from "../AppBaseButton";

const smallCompoundButtonStyles: IButtonStyles = {
  root: {
    padding: 8,
    minHeight: 68,
    minWidth: 210,
  },
  textContainer: {
    fontSize: 12,
    marginLeft: 8,
  },
};

export function getCompoundButtonSizedStyles(
  size: ActionControlSize,
  externalStyles?: IButtonStyles
): IButtonStyles | undefined {
  switch (size) {
    case ActionControlSize.Small:
      return mergeStyleSets(smallCompoundButtonStyles, externalStyles);
  }
  return externalStyles;
}

const actionCompoundButtonStyles: IButtonStyles = {
  root: {
    padding: "12px 20px 16px 17px",
  },
  label: {
    marginLeft: 0,
    fontWeight: FontWeights.bold,
  },
};

export const getActionCompoundButtonStyles = memoizeFunction(
  (theme: ITheme, customStyles?: IButtonStyles): IButtonStyles => {
    return concatStyleSets(
      getActionButtonStyles(theme),
      actionCompoundButtonStyles,
      customStyles
    );
  }
);
